import { render, staticRenderFns } from "./survey-template-list.vue?vue&type=template&id=1900cc54"
import script from "./survey-template-list.vue?vue&type=script&lang=js"
export * from "./survey-template-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports